/**
 * Feedback event name.
 *
 * * [click-suggestion](https://findify.readme.io/reference#section-click-suggestion-event) - Click-suggestion event.
 * * [click-item](https://findify.readme.io/reference#section-click-item-event) - Click-item event.
 * * [redirect](https://findify.readme.io/reference#section-page-redirect-event) - Page redirect event.
 * * [purchase](https://findify.readme.io/reference#section-purchase-event) - Purchase event.
 * * [add-to-cart](https://findify.readme.io/reference#section-add-to-cart-event) - Add-to-cart event.
 * * [update-cart](https://findify.readme.io/reference#section-cart-event) - Cart event.
 * * [view-page](https://findify.readme.io/reference#section-page-view) - Page view event.
 */
export var Event;
(function (Event) {
    Event["ClickSuggestion"] = "click-suggestion";
    Event["ClickItem"] = "click-item";
    Event["Redirect"] = "redirect";
    Event["Purchase"] = "purchase";
    Event["AddToCart"] = "add-to-cart";
    Event["UpdateCart"] = "update-cart";
    Event["ViewPage"] = "view-page";
})(Event || (Event = {}));
